import { render } from "./designfoodslide6.vue?vue&type=template&id=425a7f8a&scoped=true"
import script from "./designfoodslide6.vue?vue&type=script&lang=js"
export * from "./designfoodslide6.vue?vue&type=script&lang=js"

import "./designfoodslide6.vue?vue&type=style&index=0&id=425a7f8a&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425a7f8a"]])

export default __exports__